import api from '../api'

const getNotifications = (token) => {
  return api.privateGet('/v1/notifications/', {token})
}

export default {
  getNotifications
}
